import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

export type RentAnalyticsExpenseVisibilityDto = {
    hiddenExpenseKeys: string[];
};

export const useRentAnalyticsExpenseVisibilityApi = () => {
    const axiosInstance = useAxiosAuth();

    const { data, isLoading, isError } = useQuery({
        queryKey: [ApiConfig.queries.features.finances.queryKeys.rentAnalyticsExpenseVisibility],
        queryFn: async (): Promise<RentAnalyticsExpenseVisibilityDto> => {
            const url = ApiConfig.queries.features.finances.endpoints.rentAnalyticsExpenseVisibility;
            const response = await axiosInstance.get<RentAnalyticsExpenseVisibilityDto>(url);
            return response.data;
        },
    });

    const hiddenExpenseKeySet = new Set(
        (data?.hiddenExpenseKeys ?? []).map((k) => k.toLowerCase()),
    );

    return {
        hiddenExpenseKeys: data?.hiddenExpenseKeys ?? [],
        hiddenExpenseKeySet,
        isLoadingRentAnalyticsVisibility: isLoading,
        isErrorRentAnalyticsVisibility: isError,
    };
};
